import styled from 'styled-components'
import ContentLoader from 'react-content-loader'

const StyledSingleTableLoader = styled.div`
  background-color: white;
  margin-top: 1rem;
  height: 100%;
  width: 100%;
`

const SingleTableLoader = ({
  backgroundColor = '#f3f3f3',
  foregroundColor = '#ecebeb',
}) => {
  return (
    <StyledSingleTableLoader>
      <ContentLoader
        backgroundColor={backgroundColor}
        foregroundColor={foregroundColor}
        viewBox="0 0 778 335"
      >
        {/*Header column*/}
        <rect x="0" y="0" rx="0" ry="0" width="100%" height="35" />
        {/* Side borders*/}
        <rect x="0" y="30" rx="0" ry="0" width="4" height="100%" />
        <rect x="774" y="30" rx="0" ry="0" width="4" height="100%" />
        {/* Border Rows */}
        <rect x="0" y="64" rx="0" ry="0" width="99.5%" height="1" />
        <rect x="0" y="91" rx="0" ry="0" width="99.5%" height="1" />
        <rect x="0" y="118" rx="0" ry="0" width="99.5%" height="1" />
        <rect x="0" y="145" rx="0" ry="0" width="99.5%" height="1" />
        <rect x="0" y="172" rx="0" ry="0" width="99.5%" height="1" />
        <rect x="0" y="199" rx="0" ry="0" width="99.5%" height="1" />
        <rect x="0" y="226" rx="0" ry="0" width="99.5%" height="1" />
        <rect x="0" y="253" rx="0" ry="0" width="99.5%" height="1" />
        <rect x="0" y="280" rx="0" ry="0" width="99.5%" height="1" />
        <rect x="0" y="307" rx="0" ry="0" width="99.5%" height="1" />
        <rect x="0" y="333" rx="0" ry="0" width="99.5%" height="3" />
        {/*Bottom Border*/}
        <rect x="0" y="3361" rx="0" ry="0" width="99.5%" height="3" />
      </ContentLoader>
    </StyledSingleTableLoader>
  )
}

SingleTableLoader.metadata = {
  description: 'Single Table Loader',
  filename: 'SingleTable',
}

export default SingleTableLoader
